<template>
    <div>
        <div class="tabulation-title">
            <h5>
                <v-icon>label_outline</v-icon> Liens divers (vidéos, etc.)
            </h5>
        </div>

        <div>
            <div>
                <v-btn class="default-button mt-3 mb-3" @click="addLink">
                    <v-icon>add</v-icon> Ajouter un lien
                </v-btn>
            </div>

            <div v-for="(link, index) in currentProduct.links">
                <div class="d-flex justify-content-between">
                    <v-text-field
                        v-model="link.value"
                        label="URL"
                        :class="{'input-error': checkUrlFormat(link.value) !== ''}"
                        outlined>
                    </v-text-field>

                    <v-btn icon color="error" class="ml-4" style="margin-top: 10px" @click="removeLink(index)">
                        <v-icon large>delete</v-icon>
                    </v-btn>
                </div>

                <div class="txt-error mt-1">
                    {{ checkUrlFormat(link.value) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex"

export default {
    name: "AuraLink",
    computed: {
        ...mapState('aura', ['currentProduct']),
    },
    methods: {
        addLink() {
            let link = { value: null }

            this.currentProduct.links.push(link)
        },
        removeLink(index) {
            this.currentProduct.links.splice(index, 1)
        },
        checkUrlFormat(url) {
            let result = ''

            if(url !== null) {
                let isValidUrl = url.indexOf(' ') === -1
                result = isValidUrl ? '' : 'Le format de l\'URL n\'est pas correct'
            }

            return result
        }
    }
}
</script>